import { selectSubmittingOrgs } from 'store/entities/configuration/configurationSelectors';
import { IStore } from 'store/configureStore';

export const selectSubmittingOrgsForControllingOrg = (controllingOrgId: string) => (state: IStore) => {
    const submittingOrgs = selectSubmittingOrgs(state);
    return submittingOrgs
        .filter(submittingOrg => submittingOrg.controlling_org_id === controllingOrgId);
};
